





import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class CommentTextarea extends Vue {
  @Prop({ required: false, default: false }) disabled!: boolean;
  @Prop({ required: true, default: '' }) value!: string;

  @Prop({ required: false, default: 32 }) minHeight!: number;
  @Prop({ required: false, default: 81 }) maxHeight!: number;

  autosize = true;
  maxHeightScroll = true;
  height = '32px';

  mounted() {
    this.resize();
  }

  resize() {
    this.height = `auto`;

    this.$nextTick(() => {
      let contentHeight = this.$el.scrollHeight + 1;

      if (this.minHeight) {
        contentHeight = contentHeight < this.minHeight ? this.minHeight : contentHeight;
      }

      if (this.maxHeight) {
        if (contentHeight > this.maxHeight) {
          contentHeight = this.maxHeight;
          this.maxHeightScroll = true;
        } else {
          this.maxHeightScroll = false;
        }
      }

      const heightVal = contentHeight + 'px';
      this.height = heightVal;
    });

    return this;
  }

  highLight(type: 'red') {
    if (type === 'red') {
      this.flashClass('comment-textarea_highlight-red');
    }
  }

  flashClass(className: string, duration = 1000) {
    if (!this.$el.classList.contains(className)) {
      this.$el.classList.add(className);
      setTimeout(() => {
        this.$el.classList.remove(className);
      }, duration);
    }
  }

  @Watch('message')
  @Watch('maxHeight')
  @Watch('minHeight')
  nextTickResize() {
    this.$nextTick(this.resize);
  }

  get message() {
    return this.value;
  }

  set message(value: string) {
    this.$emit('input', value);
  }

  get computedStyles() {
    if (!this.autosize) {
      return {};
    }
    return {
      resize: 'none',
      height: this.height,
      overflow: this.maxHeightScroll ? 'auto' : 'hidden',
    };
  }
}
